import React from 'react'
import { Document, Page } from "react-pdf";
import { useState, useCallback } from "react";
import "./pdfModal.css";
import { faMagnifyingGlassPlus, faMagnifyingGlassMinus, faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";



export const PdfModal = ({ open, pdfFile, onClose }) => {
    const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.0); 

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setPageNumber(1);
  };

  const zoomIn = useCallback(() => {
    setScale((prev) => Math.min(prev + 0.2, 3.0));
  }, []);

  const zoomOut = useCallback(() => {
    setScale((prev) => Math.max(prev - 0.2, 0.3)); 
  }, []);

  const zoomReset = useCallback(() => {
    setScale(1.0);
  }, []);

  const goToPrevPage = () => setPageNumber((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () => setPageNumber((prev) => Math.min(prev + 1, numPages || 1));

  if (!open || !pdfFile) return null;

  return (
    <>
      <div className="pdf-backdrop" onClick={onClose} />
      <div className="pdf-modal">
        
        <div className="pdf-header">
          <div className="pdf-title">
            📄 Visor de PDF ({Math.round(scale * 100)}%)
          </div>
          <button className="pdf-close" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        <div className="pdf-content">
          <div className="pdf-pages-info">
            Página {pageNumber} de {numPages || 0}
          </div>
          
          <div className="pdf-viewer-container">
            <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
              <Page
                pageNumber={pageNumber}
                width={Math.min(window.innerWidth * 0.90, 1200)}
                scale={scale}  // ← ¡ACÁ APLICA EL ZOOM!
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
          </div>
        </div>

        <div className="pdf-footer">
          <div className="pdf-nav">
            {/* Navegación páginas */}
            <button onClick={goToPrevPage} disabled={pageNumber <= 1}><FontAwesomeIcon icon={faAngleLeft} /></button>
            <span>Página {pageNumber} / {numPages}</span>
            <button onClick={goToNextPage} disabled={pageNumber >= numPages}><FontAwesomeIcon icon={faAngleRight} /></button>
          </div>

          <div className="pdf-zoom">
            <button onClick={zoomOut} title="Alejar (Ctrl -)"><FontAwesomeIcon icon={faMagnifyingGlassMinus} /></button>
            <button onClick={zoomIn} title="Acercar (Ctrl +)"><FontAwesomeIcon icon={faMagnifyingGlassPlus} /></button>
            <span>{Math.round(scale * 100)}%</span>
          </div>
        </div>
      </div>
    </>
  );
}
